import styled from 'styled-components';

export const LimitedSizeTableCell = styled.td`
	max-width: 200px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;
